import styled, { css } from 'styled-components';

export const Wrapper = styled.div(
  ({ theme }) => css`
    background-color: ${theme.co.neutral99};
    border-radius: ${theme.bo.mediumSmall};
    box-shadow: 0 ${theme.sz.s05} ${theme.sz.s1} 0 rgba(0, 0, 0, 0.25);
    overflow: hidden;
  `,
);

export const Head = styled.div(
  ({ theme }) => css`
    ${theme.typography.heading.mobile.xs};
    align-items: center;
    background-color: ${theme.co.primary40};
    border-radius: ${theme.sz.s2};
    display: flex;
    justify-content: space-between;
    padding: ${theme.sz.s2} ${theme.sz.s4};

    @media (min-width: ${theme.sz.minMobileBreakpoint}) {
      ${theme.typography.heading.desktop.s}
      padding: ${theme.sz.s4} ${theme.sz.s6};
    }
  `,
);

export const Title = styled.div(() => css``);

export const Points = styled.span(() => css``);

export const Body = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s6};
    padding-bottom: ${theme.sz.s5};
    padding-left: ${theme.sz.s2};
    padding-right: ${theme.sz.s2};
    padding-top: ${theme.sz.s4};

    @media (min-width: ${theme.sz.md}) {
      padding-bottom: ${theme.sz.s8};
      padding-left: ${theme.sz.s4};
      padding-top: ${theme.sz.s6};
      padding-right: ${theme.sz.s4};
    }

    @media (min-width: ${theme.sz.xxl}) {
      flex-direction: row;
      padding-left: ${theme.sz.s6};
      padding-right: ${theme.sz.s6};

      > * {
        flex: 1;
      }
    }
  `,
);
